import {CoverageLevelModel} from '../models/plans.model';

export const isOfferedForSelection = (level: CoverageLevelModel): boolean => level?.isCollapsedForDisplay !== true;
